import { events, messageBus } from '@schibsted-nmp/advertising-events';
import { companionReadyPlacementListener } from '@client/utils/events/companionReadyPlacementListener';
import {
  PageType,
  PlacementInstructionConfig
} from '@schibsted-nmp/advertising-shared';

import { searchFilterCallback } from '../../xandr/refreshKeywords';

type setupEventsProps = {
  placementInstructionConfigs: PlacementInstructionConfig[];
  pageType: PageType;
  isAfsEnabled: boolean;
};

export function setupEvents({
  placementInstructionConfigs,
  pageType,
  isAfsEnabled
}: setupEventsProps) {
  if (placementInstructionConfigs.length > 0) {
    companionReadyPlacementListener({
      placementInstructionConfigs,
      isAfsEnabled
    });
  }

  if (pageType === 'result') {
    messageBus.subscribe(
      events.SEARCH.channel,
      events.SEARCH.FILTER.topic,
      searchFilterCallback
    );
  }
}
